import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, FileText } from "lucide-react";

export default function BottomCTA() {
  return (
    <section className="bottom-cta-section">
      <div className="landing-container bottom-cta-inner">
        <div className="bottom-cta-eyebrow">GET STARTED</div>
        <h2 className="bottom-cta-title">
          Ready to Screen Your Carbon Risk?
        </h2>
        <p className="bottom-cta-sub">
          Upload your GST data and receive a structured carbon intensity score,
          Green Score, and risk classification — in minutes.
        </p>

        <div className="bottom-cta-actions">
          <Link to="/login" className="hero-cta-primary">
            Start Screening Now
            <ArrowRight size={16} />
          </Link>
          <a
            href="/greensetu_methodology_v1.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="hero-cta-secondary"
          >
            <FileText size={15} />
            Download Methodology
          </a>
        </div>

        <p className="bottom-cta-note">
          Free to start — 2 screening runs, no credit card required.{" "}
          Banks &amp; institutions needing bulk access: <a href="mailto:carbon@rsustain.com">carbon@rsustain.com</a>
        </p>
      </div>
    </section>
  );
}
